module.exports = __webpack_public_path__ + "static/media/MC T7.4779e66c.jpg";